<template>
  <div id="index">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <!-- 头部焦点图 -->
    <banner v-bind:pageTypeId="pageTypeId"></banner>
    <div class="search_tab">
      <div class="search_tab_c">
        <router-link :to="{ path: '/search', query: { keyword: keyword } }"
          ><span :class="{ side: num == 0 }">全部</span>
        </router-link>
        <router-link
          :to="{ path: '/search_course', query: { keyword: keyword } }"
          ><span :class="{ side: num == 1 }">课程</span>
        </router-link>
        <router-link
          :to="{ path: '/search_pubilc', query: { keyword: keyword } }"
          ><span :class="{ side: num == 2 }">公开课</span>
        </router-link>
        <router-link
          :to="{ path: '/search_selfStudy', query: { keyword: keyword } }"
          ><span :class="{ side: num == 3 }">自学备考</span></router-link
        >
      </div>
    </div>
    <div class="main">
      <div class="search_null" v-if="pubilcArrNum == 0">
        <img src="../../assets/courselist/search.png" alt="" class="wuImg" />
        <p>没有找到匹配的结果</p>
      </div>
      <div class="search_main publicClass_main" v-else>
        <div class="search_con">
          公开课找到{{ pubilcArrNum }}条结果<router-link
            :to="{ path: '/publicclass_list', query: { nav: 3 } }"
          >
            去公开课列表页试试更精准的搜索&gt;&gt;</router-link
          >
        </div>
        <ul class="clearfix">
          <li v-for="(item, index) in pubilcArr">
            <router-link
              :to="{
                path: 'publicClass_details',
                query: { nav: 3, KId: item.Id }
              }"
            >
              <dl>
                <dt><img :src="item.CoverImg" /></dt>
                <dd>
                  <h2>{{ item.Title }}</h2>
                  <p class="p1" v-if="item.Label">
                    #{{ item.Label.replace(/,/g, "#") }}
                  </p>
                  <p class="p2">
                    {{ item.EndTime }}
                  </p>
                  <div class="p3">
                    <em><img :src="item.Field2"/></em>
                    <span>{{ item.Field1 }}</span>
                    <strong>￥{{ item.Price }}</strong>
                  </div>
                </dd>
              </dl>
            </router-link>
          </li>
        </ul>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="12"
            :total="total"
            background
            layout="total,prev, pager, next, jumper,->"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
import banner from "../../page2/banner/banner.vue"; //头部banner图
export default {
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    banner
  },
  metaInfo() {
    return {
      title: "启德考培在线 - 启德考培旗下在线课堂_出国考试在线培训_考培网校",
      meta: [
        {
          name: "keywords",
          content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      pageTypeId: 13, //首页banner图
      num: 2,
      listBox: [], //列表盒子
      limit: 12,
      currentPage: 1,
      courseType: 0,
      keyword: "",
      pubilcArr: [],
      pubilcArrNum: 0,
      total: 0 //总条数
    };
  },
  created() {
    //自动触发写入的函数
    let that = this;
    that.keyword = that.$route.query.keyword;
    // 公开课
    that.getSearch(that.currentPage, 183, that.limit, that.keyword);
  },
  methods: {
    iconShrink() {
      this.screenup = true;
    },
    iconOpen() {
      this.screenup = false;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      let that = this;
      // console.log(`当前页: ${val}`);
      that.currentPage = val;
      // 公开课
      that.getSearch(that.currentPage, 183, that.limit, that.keyword);
    },
    getSearch(currentPage, courseType, limit, keyword) {
      console.log("keyword", currentPage, courseType, limit, keyword);
      let that = this;
      this.$api.get(
        "https://schoolapi.eiceducation.com.cn/api/Search?page=" +
          currentPage +
          "&limit=" +
          limit +
          "&ContentType=" +
          courseType +
          "&keyword=" +
          keyword,
        "",
        res => {
          console.log(res, "res");
          if (res.data.code == 200) {
            if (courseType == 183) {
              that.total = res.data.count;
              that.pubilcArrNum = res.data.count;
              that.pubilcArr = res.data.results;
            }
            console.log(that.pubilcArr, "pubilcArr");
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.search_tab {
  padding: 18px;
  background: #fff;
}

.search_tab_c {
  width: 1180px;
  margin: 0 auto;
}

.search_tab span {
  display: inline-block;
  min-width: 96px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  border-radius: 18px;
  margin-right: 5px;
  color: #333333;
  text-align: center;
  cursor: pointer;
  padding: 0 20px;
  box-sizing: border-box;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.search_tab span:hover {
  color: #4e5cf6;
}

.search_tab span.side {
  background: #f8f8f8;
  color: #4e5cf6;
}

.main {
  width: 100%;
  background: #fafafa;
  padding-top: 24px;
  padding-bottom: 78px;
}

.search_con {
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  height: 40px;
}

.search_con a {
  float: right;
  color: #4e5cf6;
  font-size: 16px;
}

.search_main {
  width: 1180px;
  margin: 0 auto;
}

.class_main ul {
  padding-bottom: 60px;
}

.class_main ul li {
  width: 280px;
  height: 346px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
}

.class_main ul li:nth-child(4n) {
  margin-right: 0;
}

.class_main ul li dt {
  width: 280px;
  height: 174px;
  overflow: hidden;
}

.class_main ul li dt img {
  width: 100%;
}

.class_main ul li dd {
  padding: 0 16px;
  padding-top: 20px;
  text-align: left;
}

.class_main ul li dd h2 {
  font-size: 16px;
  color: #333;
  line-height: 16px;
  margin-bottom: 8px;
  font-weight: normal;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class_main ul li dd .p1 {
  width: 100%;
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 8px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class_main ul li dd .p2 {
  line-height: 20px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #999;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class_main ul li dd .p3 {
  height: 38px;
}

.class_main ul li dd .p3 strong {
  font-size: 24px;
  float: right;
  line-height: 38px;
  color: #333;
}

.block {
  width: 1180px;
  margin: 0 auto;
  text-align: right;
}

.search_null {
  width: 1180px;
  margin: 0 auto;
  text-align: center;
}

.search_null p {
  font-size: 12px;
  color: #333;
  line-height: 24px;
}
.publicClass_main ul li {
  width: 280px;
  height: 350px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  position: relative;
}

.publicClass_main ul li:nth-child(4n) {
  margin-right: 0;
}

.publicClass_main ul li dt {
  width: 280px;
  height: 174px;
  overflow: hidden;
}

.publicClass_main ul li dt img {
  width: 280px;
  height: 174px;
}

.publicClass_main ul li dd {
  padding: 0 16px;
  padding-top: 20px;
  text-align: left;
}

.publicClass_main ul li dd h2 {
  font-size: 16px;
  color: #333;
  height: 20px;
  line-height: 18px;
  margin-bottom: 8px;
  font-weight: normal;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.publicClass_main ul li dd .p1 {
  width: 100%;
  font-size: 14px;
  color: #ff9d00;
  line-height: 16px;
  margin-bottom: 8px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.publicClass_main ul li dd .p2 {
  font-size: 12px;
  color: #999;
  line-height: 12px;
  margin-bottom: 24px;
}

.publicClass_main ul li dd .p3 {
  height: 38px;
}

.publicClass_main ul li dd .p3 em {
  display: block;
  width: 34px;
  height: 34px;
  border: 2px #f5f6f6 solid;
  border-radius: 38px;
  float: left;
  overflow: hidden;
  margin-right: 8px;
}

.publicClass_main ul li dd .p3 em img {
  width: 34px;
  height: 34px;
}

.publicClass_main ul li dd .p3 span {
  font-size: 14px;
  color: #333;
  line-height: 38px;
}

.publicClass_main ul li dd .p3 strong {
  font-size: 24px;
  float: right;
  line-height: 38px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/page2/search/search_pubilc.vue